import ModalHeader from '@molecules/ModalHeader';
import ModalWindow from '@organisms/modals/ModalWindow';
import {FC} from 'react';
import {
  ButtonsWrapper,
  ModalContent,
  ModalWrapper,
  DeleteUsersEmailsWrapper,
} from './DeleteTestModal.styles';
import Button from '@atoms/Button';
import Text from '@atoms/Text';
import {ISystem} from '@types';
import {useDispatch} from 'react-redux';
import {AppDispatch} from '@store';
import {deleteSystem} from '@store/slices/systems';
import {toast} from "react-toastify";
import Toast from "@atoms/Toast";

interface Props {
  isOpened: boolean;
  system?: ISystem;
  onCloseRequest: () => void;
}

const DeleteSystemModal: FC<Props> = ({isOpened, onCloseRequest, system}) => {
  const dispatch = useDispatch<AppDispatch>();

  const DeleteSystem = () => {
    if (system?.id) {
      dispatch(deleteSystem(system.id))
        .unwrap()
        .then(() => {
          toast.success(
            <Toast title="Готово!" text={'Система успешно удалена'} type="success" />,
          );
        })
        .catch((err: any) => {
          toast.error(
            <Toast
              title="Ошибка"
              text={err?.message || 'Не удалось удалить систему'}
              type="error"
            />,
          );
        });
    }
    onCloseRequest();
  };

  return (
    <ModalWindow isOpen={isOpened} overflowIsVisible>
      <ModalWrapper>
        <ModalHeader title={'Удалить систему'} onClose={onCloseRequest} />
        <ModalContent>
          <DeleteUsersEmailsWrapper>
            <Text text={`Вы уверены, что хотите удалить систему `} display="inline" />
            <Text text={`${system?.name}`} type="bodyM" display="inline" />
            <Text text="?" display="inline" />
            <Text text="Это действие необратимо." />
          </DeleteUsersEmailsWrapper>
        </ModalContent>
        <ButtonsWrapper>
          <Button
            fullWidth
            title="Удалить"
            variant="filled"
            redButton
            onClick={DeleteSystem}
          />
          <Button
            fullWidth
            title="Отменить"
            onClick={() => {
              onCloseRequest();
            }}
          />
        </ButtonsWrapper>
      </ModalWrapper>
    </ModalWindow>
  );
};

export default DeleteSystemModal;
